import { render, staticRenderFns } from "./DataSound.vue?vue&type=template&id=5898bed6"
import script from "./DataSound.vue?vue&type=script&lang=js"
export * from "./DataSound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports